const errors = {
  operatorEmpty: 'Operator can not be empty',
  fieldEmpty: 'Field can not be empty',
  canNotBeEmpty: 'Field can not be empty',
  noOperand: 'You must enter an operand',
};

export default errors;
